import { StringKey } from '../../lang/index';

export enum PageScreen {
  MY_HOLDINGS = 'my-holdings',
  STAKEHOLDERS_HOLDINGS = 'stakeholders-holdings',
}

export const pageScreenTitle: Record<PageScreen, StringKey> = {
  [PageScreen.MY_HOLDINGS]: 'MY_HOLDINGS',
  [PageScreen.STAKEHOLDERS_HOLDINGS]: 'STAKEHOLDERS_HOLDINGS',
};

export const pageScreenTitleMap = Object.entries(pageScreenTitle);
